<template>
  <div>
    <div v-if="loading">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      
      <div class="col-md-9">
        <form-base
        class="py-5"
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Name" :required="true">
              <input
                type="text"
                @blur="$v.company.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.company.name.$error }"
                v-model="company.name"
              />

              <div class="invalid-feedback" v-if="!$v.company.name.required">
                Please enter name
              </div>
            </form-group>

            <form-group label="Code" :required="true">
              <input
                type="text"
                class="form-control"
                @blur="$v.company.code.$touch"
                :class="{ 'is-invalid': $v.company.code.$error }"
                v-model="company.code"
              />
              <div class="invalid-feedback" v-if="!$v.company.name.required">
                Please enter code
              </div>
            </form-group>

            <form-group label="Registration Number">
              <input
                type="text"
                class="form-control"
                v-model="company.registration_number"
              />
            </form-group>

            <form-group label="Contact Number">
              <input
                type="text"
                class="form-control"
                v-model="company.contact_number"
              />
            </form-group>

            <form-group label="Contact Number 2">
              <input
                type="text"
                class="form-control"
                v-model="company.contact_number_2"
              />
            </form-group>

            <form-group label="Contact Fax">
              <input
                type="text"
                class="form-control"
                v-model="company.contact_fax"
              />
            </form-group>

            <form-group label="Email Info">
              <input
                type="email"
                class="form-control"
                v-model="company.email_address_info"
              />
            </form-group>

            <form-group label="Email Accounts">
              <input
                type="email"
                class="form-control"
                v-model="company.email_address_accounts"
              />
            </form-group>

            <form-group label="Email Sales">
              <input
                type="email"
                class="form-control"
                v-model="company.email_address_sales"
              />
            </form-group>

            <form-group label="Website">
              <input
                type="text"
                class="form-control"
                v-model="company.website"
              />
            </form-group>

            <form-group label="Physical Address" :required="true">
              <textarea-autosize
                @blur="$v.company.physical_address.$touch"
                :class="{ 'is-invalid': $v.company.physical_address.$error }"
                class="form-control"
                v-model="company.physical_address"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.company.physical_address.required"
              >
                Please enter address
              </div>
            </form-group>

            <form-group label="Postal Address">
              <textarea-autosize
                class="form-control"
                v-model="company.postal_address"
              />
            </form-group>

            <form-group label="Banking Details" :required="true">
              <textarea-autosize
                class="form-control"
                v-model="company.banking_details"
              />
            </form-group>

            <form-group label="Charges VAT">
              <b-form-checkbox
                size="lg"
                v-model="company.is_vatable"
                value="1"
                unchecked-value="0"
              >
              </b-form-checkbox>
            </form-group>

            <form-group
              label="VAT Rate%"
              v-if="company.is_vatable == 1"
              :required="true"
            >
              <input
                type="number"
                max="50"
                min="1"
                @blur="$v.company.vat_rate.$touch"
                :class="{ 'is-invalid': $v.company.vat_rate.$error }"
                class="form-control w-50"
                v-model="company.vat_rate"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.company.vat_rate.required"
              >
                Please enter vat rate
              </div>
            </form-group>

            <form-group
              label="VAT Number"
              v-if="company.is_vatable == 1"
              :required="true"
            >
              <input
                type="text"
                @blur="$v.company.vat_number.$touch"
                :class="{ 'is-invalid': $v.company.vat_number.$error }"
                class="form-control"
                v-model="company.vat_number"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.company.vat_number.required"
              >
                Please enter vat number
              </div>
            </form-group>

          </template>
        </form-base>
      </div>
    </b-row>
  </div>
</template>

<script>
import companyRepo from "@/api/repos/companyRepo";
import { required,requiredIf } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup
  },

  validations: {
    company: {
      name: {
        required,
      },
      code: {
        required,
      },
      physical_address: {
        required,
      },
      vat_rate: {
        required: requiredIf(function(company) {
            return company.is_vatable == 1;
        })
      },
      vat_number: {
        required: requiredIf(function(company) {
            return company.is_vatable == 1;
        })
      },
    },
  },

  mounted() {

  },


  data() {
    return {
      company: {
        is_vatable:0
      },
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          await companyRepo.create(this.company);
         this.$root.$bvToast.toast('Company Created', {
            title: 'Success',
            autoHideDelay: 3000,
            variant: 'success',
          })
          this.$router.push({ name: 'companies'})
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast('Form Errors', {
                title: 'Errors on form data',
                autoHideDelay: 3000,
                variant: 'danger',
            })
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;         
        }
      }
    },
  },
};
</script>
